// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    // User endpoints
    LOGIN: `${API_BASE_URL}/api/users/login`,
    REGISTER: `${API_BASE_URL}/api/users/self-register`,
    PASSWORD_FORGOT: `${API_BASE_URL}/api/users/password/forgot`,
    PASSWORD_RESET: `${API_BASE_URL}/api/users/password/reset`,
    USERS: `${API_BASE_URL}/api/users`,
    USER_ME: `${API_BASE_URL}/api/users/me`,
    
    // Company info
    COMPANY_INFO: `${API_BASE_URL}/api/company-info`,
    
    // Main entities
    USTANOVE: `${API_BASE_URL}/api/ustanove`,
    APARATI: `${API_BASE_URL}/api/aparati`,
    DIJELOVI: `${API_BASE_URL}/api/dijelovi`,
    NALOZI: `${API_BASE_URL}/api/nalozi`,
    UTROSENI_DIJELOVI: `${API_BASE_URL}/api/utroseni-dijelovi`,
    
    // Reports
    REPORTS: {
      CONSUMED_PARTS: `${API_BASE_URL}/api/reports/consumed-parts`,
      PARTS_PER_APARAT: `${API_BASE_URL}/api/reports/parts-per-aparat`,
      SERVICES_PER_APARAT: `${API_BASE_URL}/api/reports/services-per-aparat`,
      SERVICES_PER_USTANOVA: `${API_BASE_URL}/api/reports/services-per-ustanova`,
      SERVICES_PER_SERVISER: `${API_BASE_URL}/api/reports/services-per-serviser`,
      TIME_PER_SERVISER: `${API_BASE_URL}/api/reports/time-per-serviser`,
      TIME_PER_APARAT_SERVISER: `${API_BASE_URL}/api/reports/time-per-aparat-serviser`,
      LOW_STOCK_PARTS: `${API_BASE_URL}/api/reports/low-stock-parts`,
    },
    
    // Audit logs
    AUDIT_LOGS: `${API_BASE_URL}/api/audit-logs`,
  }
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint, params = {}) => {
  const url = new URL(endpoint);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      url.searchParams.append(key, params[key]);
    }
  });
  return url.toString();
};

// Helper function for making authenticated requests
export const makeAuthenticatedRequest = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return fetch(url, {
    ...options,
    headers,
  });
};

// Helper function to check if user can edit a work order
export const canEditWorkOrder = async (workOrderUserId) => {
  try {
    const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    if (!currentUser || !currentUser.role) return false;
    
    // Admins can always edit
    if (currentUser.role === 'admin') return true;
    
    // Finance users cannot edit work orders
    if (currentUser.role === 'finance') return false;
    
    // For regular users, check company settings
    if (currentUser.role === 'user') {
      const response = await makeAuthenticatedRequest(API_CONFIG.ENDPOINTS.COMPANY_INFO);
      if (response.ok) {
        const companyInfo = await response.json();
        const canEditAllOrders = companyInfo.work_order_edit_enabled || false;
        
        if (canEditAllOrders) {
          // User can edit all work orders
          return true;
        } else {
          // User can only edit their own work orders
          return workOrderUserId === currentUser.id;
        }
      }
      
      // If can't fetch company info, default to own orders only
      return workOrderUserId === currentUser.id;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking work order edit permission:', error);
    return false;
  }
};

export default API_CONFIG;